import { gql } from '@apollo/client'
import { cartFieldsQuery } from '../../queries/getCart/query'

/**
 * Get's the string for `prefillCart` mutation.
 * This mutation adds a list of products to an existing cart.
 * Returns the cart with the updated products.
 * @internal
 */
export const prefillCartMutationQuery = gql`
  mutation PrefillCart(
    $storefrontName: String!
    $sessionUid: ID!
    $referrer: String
    $items: [CartProductInput]
    $replaceCart: Boolean
  ) {
    prefillCart(
      storefrontName: $storefrontName
      sessionUid: $sessionUid
      referrer: $referrer
      items: $items
      replaceCart: $replaceCart
    ) {
      ${cartFieldsQuery}
    }
  }
`

/**
 * The same mutation with `allOrNothing`, sent only by the promotion add-all
 * button under `globals.promotions.addAllOrNothing`.
 *
 * A separate document rather than an optional variable on the one above, so
 * that every other caller, and the button with the switch off, sends the
 * request text it always has. `allOrNothing` exists only on storefront
 * `v3.43.0` and later.
 * @internal
 */
export const prefillCartAllOrNothingMutationQuery = gql`
  mutation PrefillCartAllOrNothing(
    $storefrontName: String!
    $sessionUid: ID!
    $referrer: String
    $items: [CartProductInput]
    $replaceCart: Boolean
    $allOrNothing: Boolean
  ) {
    prefillCart(
      storefrontName: $storefrontName
      sessionUid: $sessionUid
      referrer: $referrer
      items: $items
      replaceCart: $replaceCart
      allOrNothing: $allOrNothing
    ) {
      ${cartFieldsQuery}
    }
  }
`

export default prefillCartMutationQuery
